module.exports = __webpack_public_path__ + "d664201f/img/rename-icon.de4e673d.svg";